import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { MOBILE_BREAKPOINT } from '../../config/constants';

export const useStyles = makeStyles<Theme>(theme => ({
    pageContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    form: {
        width: '100%',
        marginTop: '1rem',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            padding: '1.25rem',
        },
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            border: '1px solid rgb(216, 220, 229)',
            borderRadius: '8px',
            padding: '2rem',
            maxWidth: '90%',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '75%',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: '65%',
            marginTop: '2rem',
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: '55%',
        },
    },
    checkOutOrPublishButton: {
        textTransform: 'none',
        color: 'white',
        borderRadius: '50px',
        fontSize: '0.9rem',
        padding: '0.25rem 1rem',
        margin: '0 0.25rem',
        fontWeight: 400,
        '&:hover': {
            transition: 'all .2s ease-in-out',
            transform: 'scale(1.05)',
        },
    },
    checkOutButton: {
        color: 'black',
        backgroundColor: 'white',
        '&:hover': {
            color: 'black',
            backgroundColor: 'white',
        },
    },
    publishButton: {
        backgroundColor: theme.palette.success.dark,
        '&:hover': {
            backgroundColor: theme.palette.success.dark,
        },
    },

    buttonsContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: '2rem',
    },
}));
